(function (Drupal) {
    Drupal.behaviors.howCanYou = {
      attach: function (context, settings) {

        const modalBodyMap = document.querySelector('#modal-location-map .modal-body');
  

        
        if (!modalBodyMap) return;

        //const geolocationMapwrapper = modalBodyMap.querySelector('.geolocation-map-wrapper');

        ///const listGroupName = modalBodyMap.querySelector('.field--name-field-name-clinic');
        //const locationName = listGroupName ? listGroupName.innerText : '';


/* 
        const icon = document.createElement('i');
        icon.classList.add('fas', 'fa-map-marker-alt', 'location-icon');
        icon.innerHTML = `<i class="fas fa-map-marker-alt"></i> <span>${locationName}</span>`;
        
        console.log("icon", icon);

        geolocationMapwrapper.appendChild(icon); */



        //if (modalBodyMap.length === 0) return;
        const coordenadas = modalBodyMap.querySelector('.geolocation-latlng');
        if (!coordenadas) return;

        console.log("coordenadas", coordenadas);

        const [lat, lng] = coordenadas.innerText.split(',');
        const iframeUrl = `https://www.google.com/maps/embed/v1/place?key=AIzaSyAkiYK_x_I4B2kzyoP5YdHRH2c19fq9Yts&q=${lat},${lng}&zoom=15`;
        const iframe = document.createElement('iframe');
        
       /*  const listGroupName = modalBodyMap.querySelector('.field--name-field-name-clinic');
        const locationName = listGroupName ? listGroupName.innerText : ''; */

        iframe.width = "300";
        iframe.height = "300";
        iframe.style.border = "0";
        iframe.src = iframeUrl;
        iframe.allowFullscreen = true;
        iframe.loading = "lazy";
        
        modalBodyMap.querySelector('.modal-body__left').innerHTML = '';
        modalBodyMap.querySelector('.modal-body__left').appendChild(iframe);
      }
    };
  })(Drupal);
  